export default {"src":"/_next/static/media/telangana.6f1c39b1.svg","height":336,"width":292,"blurWidth":0,"blurHeight":0};